import React from "react";

import styles from "./FacetToggle.module.css";

export type FacetToggleProps = {
    expandFacets: boolean;
    facetBlockId: string;
    // Alternatively: ReturnType<typeof useState<typeof expandFacets>>[0]
    setExpandFacets: React.Dispatch<React.SetStateAction<boolean>>;
};

const FacetToggle = ({
    expandFacets = true,
    facetBlockId,
    setExpandFacets,
}: FacetToggleProps) => {
    const actionText = expandFacets ? "Hide" : "Show";

    type OptionalButtonProps = {
        "aria-expanded"?: boolean;
        "aria-controls"?: string;
    };
    const optionalProps: OptionalButtonProps = {};
    if (expandFacets) {
        optionalProps["aria-expanded"] = true;
        if (facetBlockId) {
            optionalProps["aria-controls"] = facetBlockId;
        }
    }
    const handleToggleFacets = () => setExpandFacets(!expandFacets);

    return (
        <div className={styles.row}>
            <button
                type="button"
                {...optionalProps}
                className={styles.facetToggle}
                onClick={handleToggleFacets}
            >
                {actionText} Filters
            </button>
        </div>
    );
};

export default FacetToggle;
